/* Status Glow — Model A bridge (storefront).
   Connects the finished design to a temporary Shopify product + native cart.
   Loaded on the storefront only. Safe no-op in the prototype (no /api, no /cart). */
(function () {
  window.SG = window.SG || {};
  var API = window.SG_API_BASE || "/api";
  var prep = null;      // Promise<{ variantId, mockupUrl, logoUrl }>
  var lastKey = null;

  function key(d) { try { return JSON.stringify(d); } catch (e) { return String(Math.random()); } }

  /* Runs in the BACKGROUND the moment the design is finalised (confirm pop-up opens).
     Renders the PNG, then asks the backend to stage files + create the temp product. */
  window.SG.prepareOrder = function (design) {
    if (!design) return Promise.reject(new Error("no design"));
    var k = key(design);
    if (prep && lastKey === k) return prep;        // design unchanged → reuse in-flight/finished create
    lastKey = k;
    var mockup = window.SG.renderMockupPNG ? window.SG.renderMockupPNG({ lit: false }) : Promise.resolve(null);
    prep = mockup.then(function (mockupDataUrl) {
      return fetch(API + "/create-temp-product", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ design: design, mockupDataUrl: mockupDataUrl, logoDataUrl: design.logoDataUrl || null })
      }).then(function (r) { if (!r.ok) throw new Error("create failed " + r.status); return r.json(); });
    });
    return prep;
  };

  /* Buy click → add the temp variant to the NATIVE cart, attach persistent URLs, go to checkout. */
  window.SG.addToCart = function () {
    /* Re-price against the design as it stands at this moment.
       Add-ons can be ticked inside the confirm modal, i.e. AFTER prepareOrder
       has already created a temp product. Reusing that promise charged the
       pre-add-on price while still listing the add-ons in the line properties.
       prepareOrder de-dupes on the design itself, so an unchanged design
       reuses the product it already made and no extra call is sent. */
    prep = window.SG.prepareOrder(window.SG.getDesign());
    return prep.then(function (res) {
      if (!res || !res.variantId) throw new Error("no variant id");
      var d = window.SG.design || {};
      var ao = d.addOns || {};
      var activeAddons = [
        ao.waterproof      && "Waterproofing",
        ao.wallMount       && "Wall Mounting",
        ao.remote          && "Remote Dimmer",
        ao.quickAdhesive   && "Quick Adhesive Installation",
        ao.rush            && "Rush Order"
      ].filter(Boolean);
      var props = {
        "Text":          (d.text || "").replace(/\n/g, " / "),
        "Font":          d.font && d.font.name,
        "Colour":        d.colour && d.colour.name,
        "Size":          d.size ? (d.size.widthCm + "cm × ~" + d.size.heightCm + "cm" + (d.size.custom ? " (custom)" : "")) : "",
        "Acrylic":       d.board + " · " + d.boardColour,
        "Alignment":     d.align || "centre",
        "Power adaptor": d.power,
        "Add-ons":       activeAddons.length ? activeAddons.join(", ") : "None",
        // underscore-prefixed = hidden from cart UI but kept on the order for fulfilment
        "_rush":         ao.rush ? "true" : "false",
        "_mockup_url":   res.mockupUrl || "",
        "_logo_url":     res.logoUrl || ""
      };
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: res.variantId, quantity: 1, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error("cart add failed " + r.status); return r.json(); });
    }).then(function () { window.location.href = "/checkout"; });
  };
})();